import { Link, Outlet, useLocation } from "react-router-dom";
import Logo from "../assets/logo.webp";
import { useState } from "react";
import { IoSearch } from "react-icons/io5";

export const Layout = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const location = useLocation();

  const handleMouseLeave = ()=>{

  }

  return (
    <div>
      <div className="w-full min-h-screen">
        {/* Main Content */}
        <Outlet />
      </div>
    </div>
  );
};
